import React from 'react';
import { ReferralStatus } from '@/types/referral.types';

interface ReferralStatusBadgeProps {
  status: ReferralStatus;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const statusConfig: Record<ReferralStatus, { label: string; colors: string }> = {
  PENDING: {
    label: 'Pending',
    colors: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  },
  ACCEPTED: {
    label: 'Accepted',
    colors: 'bg-blue-100 text-blue-800 border-blue-200',
  },
  REJECTED: {
    label: 'Rejected',
    colors: 'bg-red-100 text-red-800 border-red-200',
  },
  COMPLETED: {
    label: 'Completed',
    colors: 'bg-green-100 text-green-800 border-green-200',
  },
  CANCELLED: {
    label: 'Cancelled',
    colors: 'bg-gray-100 text-gray-600 border-gray-200',
  },
};

const sizeStyles = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-sm',
  lg: 'px-3 py-1.5 text-base',
};

export const ReferralStatusBadge: React.FC<ReferralStatusBadgeProps> = ({
  status,
  size = 'md',
  className = '',
}) => {
  const config = statusConfig[status] || statusConfig.PENDING;

  return (
    <span
      className={`
        inline-flex items-center font-medium rounded-full border
        ${config.colors}
        ${sizeStyles[size]}
        ${className}
      `}
    >
      {config.label}
    </span>
  );
};

export const getReferralStatusLabel = (status: ReferralStatus): string => {
  return statusConfig[status]?.label || status;
};

export const getAllReferralStatuses = (): { value: ReferralStatus; label: string }[] => {
  return Object.entries(statusConfig).map(([value, { label }]) => ({
    value: value as ReferralStatus,
    label,
  }));
};

export default ReferralStatusBadge;
